import { useLoadingStore } from '~/stores';

export const useLoading = () => {
  const loadingStore = useLoadingStore();

  const setLoading = (composableName: string, methodName: string, isLoading: boolean) => {
    loadingStore.setLoading(composableName, methodName, isLoading);
  };

  const isLoading = (composableName: string, methodName: string): boolean => {
    return loadingStore.isLoading(composableName, methodName);
  };

  const isAnyLoading = (composableName?: string): boolean => {
    return loadingStore.isAnyLoading(composableName);
  };

  return {
    setLoading,
    isLoading,
    isAnyLoading
  };
};
